import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/config/devMode'; // must initialize before other config modules
import App from './components/App';
import { ThemeRoot } from './components/ThemeRoot';
import { loadFeatures } from '@/lib/features';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

loadFeatures(); // fire-and-forget — resolves before any ProtectedRoute check

createRoot(rootElement).render(
  <StrictMode>
    <ThemeRoot>
      <App />
    </ThemeRoot>
  </StrictMode>
);
